<template>
    <div class="col-md-12 px-0 py-0">
        <div>
            <div class="row">
                <div class="col-md-9">
                    <button
                        type="button"
                        @click="showBody(0)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 0 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Lista
                    </button>
                    <button
                        type="button"
                        @click="showCreate()"
                        :class="[
                            'btn btn-outline-primary',
                            page == 1 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Agregar
                    </button>
                    <button
                        type="button"
                        @click="showBody(3)"
                        :class="[
                            'btn btn-outline-primary',
                            page == 3 ? 'active' : '',
                        ]"
                    >
                        &nbsp;Ordenar
                    </button>
                </div>
                <div class="col-md-3">
                    <span style="font-size: 20px">Ventas Anuales</span>
                </div>
            </div>
            <div>
                <annual-sale-list-component
                    v-if="page == 0"
                    v-bind:model_id="model_id"
                    @change="callChangeList"
                ></annual-sale-list-component>
                <annual-sale-form-component
                    v-if="page == 1"
                    v-bind:model_id="annual_sales_id"
                    @change="callChangeCreate"
                    :key="componentKey"
                ></annual-sale-form-component>
                <annual-sale-form-component
                    v-if="page == 2"
                    v-bind:model_id="annual_sales_id"
                ></annual-sale-form-component>
                <annual-sale-order-component
                    v-if="page == 3"
                    v-bind:model_id="model_id"
                ></annual-sale-order-component>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        model_id: Number,
    },
    data() {
        return {
            page: 0,
            annual_sales_id: 0,
            componentKey: 1,
        };
    },
    methods: {
        showCreate() {
            this.annual_sales_id = 0;
            this.page = 1;
            this.componentKey += 1;
        },
        showBody(value) {
            this.page = value;
            this.annual_sales_id = 0;
        },
        callChangeCreate() {
            this.page = 0;
            this.annual_sales_id = 0;
        },
        callChangeList(id) {
            this.annual_sales_id = id;
            this.page = 2;
        },
    },
    mounted() {},
};
</script>
